import { createContext } from 'react';

var LayoutGroupContext = createContext({});

export { LayoutGroupContext };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/context/LayoutGroupContext.mjs
// module id = +RlM
// module chunks = 0